export default [{
  name: "Gate Activity Logs",
  path: '/gate-activity-logs',
  component: () => import('../components/gate-activity-log/FacilityActivityLogs.vue'),
  meta: {
    requiresAuth: true,
    hasAccess: ['admin'],
    layout: 'master',
    re_fetch:true
  }
}]
